import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { StarIcon, ShoppingCartIcon, HeartIcon, TruckIcon, ShieldCheckIcon, RefreshCwIcon } from 'lucide-react';
import ProductCard from '../components/ui/ProductCard';
const ProductPage = () => {
  const {
    id
  } = useParams();
  const [activeTab, setActiveTab] = useState('description');
  const [activeImage, setActiveImage] = useState(0);
  // Mock product data (in a real app, this would be fetched based on the id)
  const product = {
    id: 'prod1',
    name: 'Handcrafted Leather Wallet',
    price: 49.99,
    images: ['https://images.unsplash.com/photo-1627123424574-724758594e93?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1887&q=80', 'https://images.unsplash.com/photo-1581281863883-2469417a1668?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1376&q=80', 'https://images.unsplash.com/photo-1604166694810-143ddf83852c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1376&q=80'],
    rating: 4.8,
    reviewCount: 124,
    seller: {
      name: 'Artisan Leatherworks',
      rating: 4.9,
      productCount: 42,
      joinedDate: '2020-05-15'
    },
    description: 'Handcrafted from premium full-grain leather, this wallet combines classic style with modern functionality. Each piece is meticulously crafted by skilled artisans, ensuring exceptional quality and durability.',
    features: ['Made from premium full-grain leather', 'Hand-stitched with waxed thread for durability', 'Multiple card slots and bill compartment', 'RFID blocking technology for security', 'Personalization available upon request'],
    specifications: {
      Material: 'Full-grain leather',
      Dimensions: '4.5" x 3.5" x 0.5"',
      Colors: 'Brown, Black, Tan',
      'Card Slots': '6',
      'Bill Compartments': '2',
      Weight: '85g'
    },
    stock: 15,
    shipping: {
      free: true,
      estimated: '2-4 business days'
    },
    isNew: true
  };
  // Similar products
  const similarProducts = [{
    id: 'prod3',
    name: 'Organic Cotton T-Shirt',
    price: 29.99,
    image: 'https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1480&q=80',
    rating: 4.6,
    seller: 'EcoFashion'
  }, {
    id: 'prod5',
    name: 'Handmade Ceramic Mug',
    price: 24.99,
    image: 'https://images.unsplash.com/photo-1514228742587-6b1558fcca3d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1480&q=80',
    rating: 4.9,
    seller: 'Pottery Studio',
    discount: 10
  }, {
    id: 'prod10',
    name: 'Handwoven Basket',
    price: 42.0,
    image: 'https://images.unsplash.com/photo-1616486788371-62d930495c44?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1376&q=80',
    rating: 4.9,
    seller: 'Global Artisans'
  }, {
    id: 'prod12',
    name: 'Linen Throw Pillow',
    price: 32.5,
    image: 'https://images.unsplash.com/photo-1584360507703-a329e4a75e61?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1376&q=80',
    rating: 4.7,
    seller: 'Comfort Living'
  }];
  // Quantity state
  const [quantity, setQuantity] = useState(1);
  const incrementQuantity = () => {
    if (quantity < product.stock) {
      setQuantity(quantity + 1);
    }
  };
  const decrementQuantity = () => {
    if (quantity > 1) {
      setQuantity(quantity - 1);
    }
  };
  return <div className="bg-gray-50 min-h-screen" data-id="element-586">
      <div className="container mx-auto px-4 py-8" data-id="element-587">
        {/* Breadcrumbs */}
        <div className="text-sm text-gray-500 mb-6" data-id="element-588">
          <span className="hover:text-blue-600 cursor-pointer" data-id="element-589">Home</span> &gt;
          <span className="hover:text-blue-600 cursor-pointer" data-id="element-590">
            {' '}
            Fashion & Accessories
          </span>{' '}
          &gt;
          <span className="text-gray-700" data-id="element-591"> {product.name}</span>
        </div>
        {/* Product Main Section */}
        <div className="bg-white rounded-xl shadow-sm overflow-hidden mb-10" data-id="element-592">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 p-6" data-id="element-593">
            {/* Product Images */}
            <div data-id="element-594">
              <div className="mb-4 rounded-lg overflow-hidden" data-id="element-595">
                <img src={product.images[activeImage]} alt={product.name} className="w-full h-96 object-cover" data-id="element-596" />
              </div>
              <div className="flex space-x-4" data-id="element-597">
                {product.images.map((image, index) => <div key={index} className={`w-20 h-20 rounded-md overflow-hidden cursor-pointer border-2 ${activeImage === index ? 'border-blue-500' : 'border-transparent'}`} onClick={() => setActiveImage(index)} data-id="element-598">
                    <img src={image} alt={`${product.name} view ${index + 1}`} className="w-full h-full object-cover" data-id="element-599" />
                  </div>)}
              </div>
            </div>
            {/* Product Info */}
            <div data-id="element-600">
              {product.isNew && <span className="inline-block bg-green-500 text-white text-xs font-bold px-2 py-1 rounded mb-3" data-id="element-601">
                  NEW
                </span>}
              <h1 className="text-3xl font-bold text-gray-800 mb-2" data-id="element-602">
                {product.name}
              </h1>
              <div className="flex items-center mb-4" data-id="element-603">
                <div className="flex" data-id="element-604">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} className={`h-5 w-5 ${i < Math.floor(product.rating) ? 'text-yellow-400 fill-yellow-400' : 'text-gray-300'}`} data-id="element-605" />)}
                </div>
                <span className="text-sm text-gray-600 ml-2" data-id="element-606">
                  {product.rating} ({product.reviewCount} reviews)
                </span>
              </div>
              <div className="text-2xl font-bold text-gray-800 mb-4" data-id="element-607">
                ${product.price.toFixed(2)}
              </div>
              <div className="mb-6" data-id="element-608">
                <p className="text-gray-600" data-id="element-609">{product.description}</p>
              </div>
              <div className="flex items-center space-x-4 mb-6" data-id="element-610">
                <div className="text-gray-700" data-id="element-611">Quantity:</div>
                <div className="flex items-center border border-gray-300 rounded" data-id="element-612">
                  <button className="px-3 py-1 bg-gray-100 hover:bg-gray-200" onClick={decrementQuantity} disabled={quantity <= 1} data-id="element-613">
                    -
                  </button>
                  <span className="px-4 py-1" data-id="element-614">{quantity}</span>
                  <button className="px-3 py-1 bg-gray-100 hover:bg-gray-200" onClick={incrementQuantity} disabled={quantity >= product.stock} data-id="element-615">
                    +
                  </button>
                </div>
                <div className="text-sm text-gray-500" data-id="element-616">
                  {product.stock} available
                </div>
              </div>
              <div className="flex flex-wrap gap-4 mb-6" data-id="element-617">
                <button className="flex-1 bg-blue-600 hover:bg-blue-700 text-white py-3 px-6 rounded-full font-medium flex items-center justify-center" data-id="element-618">
                  <ShoppingCartIcon className="h-5 w-5 mr-2" data-id="element-619" />
                  Add to Cart
                </button>
                <button className="p-3 rounded-full border border-gray-300 hover:bg-gray-100" data-id="element-620">
                  <HeartIcon className="h-5 w-5 text-gray-600" data-id="element-621" />
                </button>
              </div>
              {/* Seller Info */}
              <div className="border-t border-gray-200 pt-4" data-id="element-622">
                <div className="flex items-center" data-id="element-623">
                  <div className="bg-blue-100 rounded-full p-2 mr-3" data-id="element-624">
                    <span className="text-blue-600 font-semibold" data-id="element-625">
                      {product.seller.name.charAt(0)}
                    </span>
                  </div>
                  <div data-id="element-626">
                    <p className="font-medium" data-id="element-627">
                      Sold by{' '}
                      <span className="text-blue-600" data-id="element-628">
                        {product.seller.name}
                      </span>
                    </p>
                    <div className="flex items-center text-sm text-gray-500" data-id="element-629">
                      <StarIcon className="h-4 w-4 text-yellow-400 fill-yellow-400 mr-1" data-id="element-630" />
                      <span data-id="element-631">
                        {product.seller.rating} · {product.seller.productCount}{' '}
                        products
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              {/* Shipping Info */}
              <div className="mt-6 flex flex-col space-y-3" data-id="element-632">
                <div className="flex items-center text-gray-700" data-id="element-633">
                  <TruckIcon className="h-5 w-5 mr-2 text-green-600" data-id="element-634" />
                  {product.shipping.free ? <span data-id="element-635">
                      <span className="font-medium" data-id="element-636">Free shipping</span> ·
                      Estimated delivery in {product.shipping.estimated}
                    </span> : <span data-id="element-637">
                      <span className="font-medium" data-id="element-638">Standard shipping</span> ·
                      Estimated delivery in {product.shipping.estimated}
                    </span>}
                </div>
                <div className="flex items-center text-gray-700" data-id="element-639">
                  <ShieldCheckIcon className="h-5 w-5 mr-2 text-green-600" data-id="element-640" />
                  <span data-id="element-641">Secure payment & buyer protection</span>
                </div>
                <div className="flex items-center text-gray-700" data-id="element-642">
                  <RefreshCwIcon className="h-5 w-5 mr-2 text-green-600" data-id="element-643" />
                  <span data-id="element-644">30-day returns</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Product Details Tabs */}
        <div className="bg-white rounded-xl shadow-sm overflow-hidden mb-10" data-id="element-645">
          <div className="border-b border-gray-200" data-id="element-646">
            <div className="flex flex-wrap" data-id="element-647">
              <button className={`px-6 py-3 font-medium text-sm ${activeTab === 'description' ? 'border-b-2 border-blue-600 text-blue-600' : 'text-gray-600'}`} onClick={() => setActiveTab('description')} data-id="element-648">
                Description
              </button>
              <button className={`px-6 py-3 font-medium text-sm ${activeTab === 'features' ? 'border-b-2 border-blue-600 text-blue-600' : 'text-gray-600'}`} onClick={() => setActiveTab('features')} data-id="element-649">
                Features
              </button>
              <button className={`px-6 py-3 font-medium text-sm ${activeTab === 'specifications' ? 'border-b-2 border-blue-600 text-blue-600' : 'text-gray-600'}`} onClick={() => setActiveTab('specifications')} data-id="element-650">
                Specifications
              </button>
              <button className={`px-6 py-3 font-medium text-sm ${activeTab === 'reviews' ? 'border-b-2 border-blue-600 text-blue-600' : 'text-gray-600'}`} onClick={() => setActiveTab('reviews')} data-id="element-651">
                Reviews ({product.reviewCount})
              </button>
            </div>
          </div>
          <div className="p-6" data-id="element-652">
            {activeTab === 'description' && <div data-id="element-653">
                <p className="text-gray-700" data-id="element-654">{product.description}</p>
                <p className="text-gray-700 mt-4" data-id="element-655">
                  Each wallet is carefully inspected to ensure it meets our high
                  standards of quality. The natural leather will develop a
                  beautiful patina over time, making each piece uniquely yours.
                </p>
                <p className="text-gray-700 mt-4" data-id="element-656">
                  Our artisans have been crafting leather goods for generations,
                  using traditional techniques combined with modern designs.
                  We're proud to offer products that are built to last.
                </p>
              </div>}
            {activeTab === 'features' && <ul className="list-disc pl-5 space-y-2 text-gray-700" data-id="element-657">
                {product.features.map((feature, index) => <li key={index} data-id="element-658">{feature}</li>)}
              </ul>}
            {activeTab === 'specifications' && <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-659">
                {Object.entries(product.specifications).map(([key, value]) => <div key={key} className="flex" data-id="element-660">
                    <div className="w-1/3 font-medium text-gray-700" data-id="element-661">{key}</div>
                    <div className="w-2/3 text-gray-600" data-id="element-662">{value}</div>
                  </div>)}
              </div>}
            {activeTab === 'reviews' && <div data-id="element-663">
                <div className="flex items-center mb-6" data-id="element-664">
                  <div className="mr-4" data-id="element-665">
                    <div className="text-5xl font-bold text-gray-800" data-id="element-666">
                      {product.rating}
                    </div>
                    <div className="flex" data-id="element-667">
                      {[...Array(5)].map((_, i) => <StarIcon key={i} className={`h-5 w-5 ${i < Math.floor(product.rating) ? 'text-yellow-400 fill-yellow-400' : 'text-gray-300'}`} data-id="element-668" />)}
                    </div>
                    <div className="text-sm text-gray-500 mt-1" data-id="element-669">
                      {product.reviewCount} reviews
                    </div>
                  </div>
                  <div className="flex-1" data-id="element-670">
                    {/* Rating bars would go here */}
                    <div className="text-center" data-id="element-671">
                      <button className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-full text-sm font-medium" data-id="element-672">
                        Write a Review
                      </button>
                    </div>
                  </div>
                </div>
                <div className="text-center py-8 text-gray-600" data-id="element-673">
                  Reviews will appear here after customers leave feedback.
                </div>
              </div>}
          </div>
        </div>
        {/* Similar Products */}
        <div className="mb-10" data-id="element-674">
          <h2 className="text-2xl font-bold mb-6" data-id="element-675">You May Also Like</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-676">
            {similarProducts.map(product => <ProductCard key={product.id} id={product.id} name={product.name} price={product.price} image={product.image} rating={product.rating} seller={product.seller} discount={product.discount} data-id="element-677" />)}
          </div>
        </div>
      </div>
    </div>;
};
export default ProductPage;